import React, { useState } from 'react'
import './Contact.css'
import emailjs from '@emailjs/browser';

import { useRef } from 'react';
const Contact = () => {
    const form = useRef();


    const [done, SetDone] = useState(false)

    const sendEmail = (e) => {
      e.preventDefault();
  
      emailjs.sendForm('service_962urrd', 'template_4h8s1xm', form.current, 'RUae74x9S0XVA5mdy')
        .then((result) => {
            console.log(result.text);
            SetDone(true);
        }, (error) => {
            console.log(error.text);
        });
    };

  return (
    <div className="contact" id='Contact'>
        <div className="c-left">
            <div className="span">
                <span>Get in touch</span>
                <span>Shoot me a message</span>
                <div className="blur s-blur1"
                     style={{background: "#ABF1FF94"}}>
                </div>
            </div>
        </div>
        <div className="c-right">
            <form ref={form} onSubmit={sendEmail}>
                <input type='text' name='user_name' className='user' placeholder='Name'/>
                <input type='email' name='user_email' className='user' placeholder='Email'/>
                <textarea name='message' className='user' placeholder='Message'/>
                <input type='submit' value='send' className='button'/>
                <span>{done && "Message sent!"}</span>
                <div className="blur c-blur1"
                     style={{background:"var(--purple)" }}>
                </div>

            </form>
        </div>
    </div>
  )
}

export default Contact